export default __webpack_public_path__ + "static/media/max_purchase.66b721ed.png";